import { ChangeDetectionStrategy, Component, input, output } from '@angular/core';
import { GalleryDto } from '@nusign/picflow-backend-types';
import { ColorPickerComponent } from '../../../color-picker/color-picker.component';
import { ColorSelectorComponent } from '../../../color-selector/color-selector.component';
import { ContextMenuComponent } from '../../../shared/components/context-menu/context-menu.component';
import { AccessItemCtaComponent } from '../access-item-cta/access-item-cta.component';
import { AccessItemHeaderComponent } from '../access-item-header/access-item-header.component';
import { AccessItemIconComponent } from '../access-item-icon/access-item-icon.component';
import { AccessItemComponent } from '../access-item/access-item.component';
import { GallerySettingsIconComponent } from '../gallery-settings-icon/gallery-settings-icon.component';

@Component({
  selector: 'app-theme-single-color-item',
  imports: [
    AccessItemComponent,
    AccessItemIconComponent,
    AccessItemHeaderComponent,
    AccessItemCtaComponent,
    ColorSelectorComponent,
    ContextMenuComponent,
    GallerySettingsIconComponent,
    ColorPickerComponent,
  ],
  changeDetection: ChangeDetectionStrategy.OnPush,
  templateUrl: './theme-single-color-item.component.html',
  styleUrl: './theme-single-color-item.component.scss',
})
export class ThemeSingleColorItemComponent {
  gallery = input.required<GalleryDto>();
  title = input<string>('Color');
  color = input.required<string>();
  allowOpacity = input<boolean>();
  small = input<boolean>();
  icon = input<string>();
  colorChange = output<string>();
}
